import { logoutAdmin } from '../auth/admin-auth';

/**
 * Создает HTML элементы для админ-панели
 * @returns {HTMLElement} Элемент админ-панели
 */
export function createAdminToolbar() {
    const adminToolbar = document.createElement('div');
    adminToolbar.id = 'admin-toolbar';
    adminToolbar.className = 'admin-toolbar d-none';
    adminToolbar.innerHTML = `
        <div class="container-fluid">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="admin-welcome">Welcome, <span id="admin-name">Admin</span></span>
                </div>
                <div class="admin-actions">
                    <button id="pages-button" class="toolbar-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                        </svg>
                        Сторінки
                    </button>
                    <button id="seo-button" class="toolbar-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0z"/>
                        </svg>
                        SEO Settings
                    </button>
                    <button id="logout-button" class="toolbar-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                            <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
                        </svg>
                        Logout
                    </button>
                </div>
            </div>
        </div>
    `;

    return adminToolbar;
}

/**
 * Настраивает обработчики событий для админ-панели
 * @param {HTMLElement} toolbar Элемент админ-панели
 * @param {Function} onSeoButtonClick Обработчик нажатия на кнопку SEO
 */
export function setupAdminToolbarHandlers(toolbar, onSeoButtonClick) {
    const pagesButton = toolbar.querySelector('#pages-button');
    const seoButton = toolbar.querySelector('#seo-button');
    const logoutButton = toolbar.querySelector('#logout-button');

    if (pagesButton) {
        pagesButton.addEventListener('click', () => {
            import('../../page-manager/page-manager.js').then(m => m.openPagesListModal());
        });
    }

    if (seoButton && typeof onSeoButtonClick === 'function') {
        seoButton.addEventListener('click', onSeoButtonClick);
    }

    if (logoutButton) {
        logoutButton.addEventListener('click', logoutAdmin);
    }
}

export function setAdminName(username) {
    const adminNameElement = document.getElementById('admin-name');
    if (adminNameElement) {
        adminNameElement.textContent = username;
    }
}

export function showAdminToolbar() {
    const adminToolbar = document.getElementById('admin-toolbar');
    if (adminToolbar) {
        adminToolbar.classList.remove('d-none');
        document.body.classList.add('admin-mode');
    }
}

export function hideAdminToolbar() {
    const adminToolbar = document.getElementById('admin-toolbar');
    if (adminToolbar) {
        adminToolbar.classList.add('d-none');
        document.body.classList.remove('admin-mode');
    }
}